$bog_bhelper_app $mol_book2_catalog
	realm <= Realm $hyoo_crus_glob
	Placeholder null
	Menu_logo $mol_image
		uri \bog/bhelper/assets/favicon_dark.ico
	menu_title @ \VibeHelpers 
	menu_tools /
		<= Theme_toggle $bog_theme_toggle
			theme_auto <= Theme
	plugins /
		<= Theme $bog_theme_auto
			theme_light \$mol_theme_light
			theme_dark \$mol_theme_dark
	spreads *
		\
			<= Bot $giper_bot
				Space null
				Sources null
				Donate null
				Support null
				Lights null
		prof <= Prof $bog_bhelper_app_prof
		crm <= Crm $bog_bhelper_app_crm
		vaka <= Vaka $bog_bhelper_app_vaka
		settings <= Settings $bog_bhelper_app_settings
		lk <= Lk $bog_lk
			Head null
			plugins /
